import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import ReactDOM from 'react-dom'
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { Grid, Typography, Input, Button, duration } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import Skeleton from '@material-ui/lab/Skeleton';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PhoneIcon from '@material-ui/icons/Phone';
import FavoriteIcon from '@material-ui/icons/Favorite';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import HelpIcon from '@material-ui/icons/Help';
import ShoppingBasket from '@material-ui/icons/ShoppingBasket';
import ThumbDown from '@material-ui/icons/ThumbDown';
import ThumbUp from '@material-ui/icons/ThumbUp';
import Box from '@material-ui/core/Box';
import Rating from '@material-ui/lab/Rating';
import { red } from '@material-ui/core/colors';
import ShareIcon from '@material-ui/icons/Share';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import YouTubeIcon from '@material-ui/icons/YouTube';
import QueueMusicIcon from '@material-ui/icons/QueueMusic';
import LibraryMusicIcon from '@material-ui/icons/LibraryMusic';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import * as SpotifyWebApi from 'spotify-web-api-js';
import SpotifyWrapper from 'ma-spotify-wrapper';

const spotify = new SpotifyWrapper({
    token: 'BQAZdCWo1TnKx8cGVlatqVz2Q1BWuJDdBkVEGnTI_kU5AaIYJUYRzuhPXt2Ph'
});

// spotify.search.artists('Incubus')
//     .then(data => {
//         console.dir(data)
//     });

const searchArtists = (artist) => {
    spotify.search.artists('Incubus')
        .then(data => {
            // so somehting with the data
            console.dir(data)
        });
}

const searchAlbums = (artist) => {
    spotify.search.albums('Incubus')
        .then(data => {
            // so somehting with the data
            console.dir(data)
        });
}

const searchTracks = (song) => {
    spotify.search.tracks(song)
        .then(data => {
            // so somehting with the data
            console.dir(data)
        });
}

const searchPlaylists = (artist) => {
    spotify.search.playlists(artist)
        .then(data => {
            // so somehting with the data
            console.dir(data)
        });
}

const getAlbum = (albumId) => {
    spotify.search.getAlbum(albumId)
        .then(data => {
            // so somehting with the data
            console.dir(data)
        });
}

const getAlbums = (ids) => { // ids is an array
    spotify.search.getAlbums(ids)
        .then(data => {
            // so somehting with the data
            console.dir(data)
        });
}

const getTracks = (ids) => { // ids is an array
    spotify.search.getTracks(ids)
        .then(data => {
            // so somehting with the data
            console.dir(data)
        });
}


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,        
	},
	videoTile: {

	},
    paper: {
        padding: theme.spacing(1),
        textAlign: 'center',
        color: '#fd5d93',//theme.palette.text.secondary,
        backgroundColor: '#6c757d',
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
      },
      expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shortest,
        }),
      },
      expandOpen: {
        transform: 'rotate(180deg)',
      },
      avatar: {
        backgroundColor: red[800],
      },
}));

const generateRandomString = (length) => {
	var text = '';
	var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  
	for (var i = 0; i < length; i++) {
	  text += possible.charAt(Math.floor(Math.random() * possible.length));
	}
	return text;
};

const MusicCard = ({source, title, value}) => {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };
    return (
        <Card className={classes.root}>
          <CardHeader
            avatar={
              <Avatar aria-label="artist" className={classes.avatar}>
                D
              </Avatar>
            }
            action={
              <IconButton aria-label="settings">
                <MoreVertIcon />
              </IconButton>
            }
            title={title}
            subheader={value + '  RCT'}
          />
          <MusicTile source='https://open.spotify.com/embed/track/2eG7o3BfbzohiETArwsX1K?si=7qY5VggPRuez9MqCgTwKHg' title='Touch, Peel and Stand' />                            
          <CardContent>
            <Typography variant="body2" color="textSecondary" component="p">
              Short Description
            </Typography>
          </CardContent>
          <CardActions disableSpacing>
            <IconButton aria-label="add to favorites">
              <FavoriteIcon />
            </IconButton>
            <IconButton aria-label="share">
              <ShareIcon />
            </IconButton>
            <IconButton
              className={clsx(classes.expand, {
                [classes.expandOpen]: expanded,
              })}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
            >
              <ExpandMoreIcon />
            </IconButton>
          </CardActions>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <CardContent>
              <Typography paragraph>About:</Typography>              
            </CardContent>
          </Collapse>
        </Card>
      );
}

const MusicTile = ({source, title, value}) => {    
    const classes = useStyles();
    const [ratings, setratings] = useState()
    const [rating, setRating] = useState(3)
    const [expanded, setExpanded] = React.useState(false);
    var client_id = '0cc8cbae575e44e6a19c24cbae8549e0'; // Your client id
    var client_secret = '99ef44f233e64a4ebc064d8bc6520578'; // Your secret
    //var redirect_uri = 'REDIRECT_URI'; // Your redirect uri

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    return (
        <div>
            <Typography>Title: {title} | Value: {value} RCT</Typography>
            <iframe src={source} width="250" height="80" frameBorder="1" allowtransparency="true" allow="encrypted-media"></iframe>
            {/* <Rating
                name="simple-controlled"
                value={rating}
                onChange={(event, newValue) => {
                    setRating(newValue);
                }}
            />     */}
        </div>
    )
}

const SpotifyContainer = () => {
	const classes = useStyles();
	const [value, setValue] = useState(0);
	const [searchQuery, setSearchQuery] = useState('');
	const [songs, setSongs] = useState([]);
	const [content, setContent] = useState('')

	const handleQueryChange = (event) => {
        setSearchQuery(event.target.value)
        console.log(event.target.value)
    }
    const searchSpotify = (event) => {
		setValue(event);
    };

    const loadSongs = () => {
        spotify.search.artists('Incubus')
        .then(data => {
            console.dir(data)
        });
    }   

    

    return (
        <div>
            <Grid container spacing={1}>
                <Grid container item xs={12} lg={12} spacing={1}>
                    <Grid item xs={12}>
						<Typography style={{ color: '#f50057' }}>
							Not paying yet, coming soon!
						</Typography><br />
                        <Paper className={classes.paper}>
                            <Input 
                                onChange={handleQueryChange}
                                id='artist' 
                                type='text'
                                value={searchQuery}
                                placeholder='artist search'
                            />
                            <Button
                                variant='contained'
                                onClick={() => {                                    
                                    searchSpotify(searchQuery);
                                }} value=''>Search</Button>
                        </Paper>
                    </Grid> 
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Paper>
                           
                        </Paper>
                    </Grid>
                </Grid>
                <Grid container item xs={12} lg={12} spacing={1}>
                    <Grid item xs={12} md={4} lg={4}>
                        <Paper className={classes.paper}>                            
                            <MusicTile source='https://open.spotify.com/embed/track/1qAuIPMALdFtGv2Ymjy5l0' title='Monsters' value='0.25' />                                                  
                            {/* <MusicCard source='https://open.spotify.com/embed/track/2eG7o3BfbzohiETArwsX1K?si=7qY5VggPRuez9MqCgTwKHg' title='Touch, Peel and Stand' value='0.21' /> */}
                        </Paper>
                    </Grid>
                    
                    <Grid item xs={12} md={4} lg={4}>
                        <Paper className={classes.paper}>
                            <MusicTile source='https://open.spotify.com/embed/track/7pNC5ZIKtwUK0ReSpM3P9f' title='Black Widow' value='0.25' />                            
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                        <Paper className={classes.paper}>
                        <MusicTile source='https://open.spotify.com/embed/track/4VqPOruhp5EdPBeR92t6lQ' title='Uprising' value='0.25' />
                        </Paper>
                    </Grid>
                </Grid>
                <Grid container item xs={12} lg={12} spacing={1}>
                    <Grid item xs={12} md={4} lg={4}>
                        <Paper className={classes.paper}>
                        <MusicTile source='https://open.spotify.com/embed/track/25I4pBnup7EeerWd61G61i' title='Timebomb' value='0.25' />
                        </Paper>
                    </Grid>
                    
                    <Grid item xs={12} md={4} lg={4}>
                        <Paper className={classes.paper}>
                        <MusicTile source='https://open.spotify.com/embed/track/6tpGF2kYnrqO0S44jKxduZ' title='Breakdown' value='0.25' />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                        <Paper className={classes.paper}>
                        <MusicTile source='https://open.spotify.com/embed/track/2UZtI2HUyLRzqBjodvcUmY' title='Rx' value='0.25' />
                        </Paper>
                    </Grid>
                </Grid>
                <Grid container item xs={12} lg={12} spacing={1}>
                    {songs.map(({data}) => {
                         return (
                            <Grid item xs={12} md={4} lg={4}>                           
                               <MusicTile source='' title='' value='.25' />
                            </Grid>
                        );
                    })}
                </Grid>
            </Grid>
        </div>
    );
}

export default SpotifyContainer;